require('./spritesheets/sprite.png');
require.context('./icons', true, /\.svg$/);
require('./scripts/main.js');
require('./styles/main.scss');
